'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const PropTypes = _interopDefault(require('prop-types'));

var OuterWrapper = styled__default.div.withConfig({
  displayName: "FixedAspect__OuterWrapper",
  componentId: "sc-1sfmm32-0"
})(["position:relative;width:100%;height:auto;padding-top:", "%;overflow:hidden;"], function (_ref) {
  var percentage = _ref.percentage;
  return percentage;
});
var InnerWrapper = styled__default.div.withConfig({
  displayName: "FixedAspect__InnerWrapper",
  componentId: "sc-1sfmm32-1"
})(["position:absolute;top:0;right:0;bottom:0;left:0;"]);

var FixAspect = function FixAspect(_ref2) {
  var _ref2$ratio = _ref2.ratio,
      ratio = _ref2$ratio === void 0 ? '1:1' : _ref2$ratio,
      children = _ref2.children;
  // Destructure resulting array into 'width' and 'height'
  var ratioArr = ratio.split(':');
  var width = parseFloat(ratioArr[0]);
  var height = parseFloat(ratioArr[1]); // Calculate percentage value using 'width' and 'height'

  var percentage = height / width * 100;
  return /*#__PURE__*/React__default.createElement(OuterWrapper, {
    percentage: percentage
  }, /*#__PURE__*/React__default.createElement(InnerWrapper, null, children));
};

FixAspect.propTypes = {
  ratio: PropTypes.string,
  children: PropTypes.any
};

module.exports = FixAspect;
